export const DISABLED_REASONS = {
  schemaLocked: 'This can’t be changed while the schema is locked.',
  noPermission: 'You don’t have permission to edit this.',
  cycleClosed: 'This isn’t available on a closed cycle.',
  externalNameLocked: 'Only admin users can edit this after a snapshot has been successfully generated for this cycle.',
}
